import { useMemo } from 'react'

import { VirtualFurnitureRoomType } from 'constants/virtualFurniture'
import constate from 'constate'
import { useActiveRoom } from 'utils/hooks'

function useStyleSelectionSetup() {

  const { allRooms, activeRoom, activeRoomIndex, setActiveRoomIndex } = useActiveRoom()

  const imagesForImageStack: string[] = useMemo(() => {
    const images: string[] = []

    if (!activeRoom) return []

    // Prune undefined urls and push existing to array
    for (let image of activeRoom.images) {
      if (!image.url) continue
      images.push(image.url)
    }

    return images
  }, [activeRoom])

  const isEmptyRoomSelected = useMemo(() => activeRoom && activeRoom.roomTypes.has(VirtualFurnitureRoomType.EMPTY_ROOM), [activeRoom])

  return {
    allRooms,
    activeRoom,
    activeRoomIndex,
    imagesForImageStack,
    isEmptyRoomSelected,
    setActiveRoomIndex,
  }
}

export const [StyleSelectionContextProvider, useStyleSelectionContext] = constate(useStyleSelectionSetup)
